"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _AlertBox = _interopRequireDefault(require("../../../domainless/feedback/AlertBox"));
var _validator = _interopRequireDefault(require("../../../../utils/validator"));
var _validationConstraints = require("./validationConstraints");
var _SNETForgotPasswordModule = _interopRequireDefault(require("./SNETForgotPassword.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SNETForgotPassword = _ref => {
  let {
    title,
    desription,
    email,
    forgotPasswordError,
    onSubmit
  } = _ref;
  const [localEmail, setEmail] = (0, _react.useState)(email);
  const [validationErr, setValidationErr] = (0, _react.useState)("");
  (0, _react.useEffect)(() => {
    if (email) {
      setEmail(email.toLowerCase());
    }
  }, [email]);
  const handleSubmit = event => {
    event.preventDefault();
    event.stopPropagation();
    setValidationErr("");
    const isNotValid = (0, _validator.default)({
      email: localEmail
    }, _validationConstraints.forgotPasswordConstraints);
    if (isNotValid) {
      setValidationErr(isNotValid[0]);
      return;
    }
    onSubmit(localEmail);
  };
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 24,
    className: _SNETForgotPasswordModule.default.forgotPwdMainContainer
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    className: _SNETForgotPasswordModule.default.forgotPwdContent
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h3"
  }, title), /*#__PURE__*/_react.default.createElement(_Typography.default, null, desription), /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    autoComplete: "off",
    className: _SNETForgotPasswordModule.default.forgotPwdForm
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    id: "outlined-username-input",
    label: "Email",
    className: _SNETForgotPasswordModule.default.textField,
    type: "text",
    name: "email",
    margin: "normal",
    variant: "outlined",
    value: localEmail,
    onChange: e => setEmail(e.target.value.toLowerCase())
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETForgotPasswordModule.default.alertBoxContainer
  }, /*#__PURE__*/_react.default.createElement(_AlertBox.default, {
    type: "error",
    message: validationErr || forgotPasswordError
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    variant: "contained",
    children: "reset password",
    type: "submit",
    onClick: handleSubmit
  }))));
};
SNETForgotPassword.propTypes = {
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  email: _propTypes.default.string,
  forgotPasswordError: _propTypes.default.string,
  onSubmit: _propTypes.default.func
};
SNETForgotPassword.defaultProps = {
  desription: "We'll email you instructions on how to reset it."
};
var _default = exports.default = SNETForgotPassword;